import { get, values } from "lodash";

type SelectorArgs = {
  chatId: string;
};

export const getComposerMessageToQuoteId = (
  state: any,
  { chatId }: SelectorArgs,
) => get(state, ["chat", "composer", chatId, "messageToQuoteId"]);

export const getComposerMessageToEditId = (
  state: any,
  { chatId }: SelectorArgs,
) => get(state, ["chat", "composer", chatId, "messageToEditId"]);

export const getComposerFileAttachments = (
  state: any,
  { chatId }: SelectorArgs,
) => get(state, ["chat", "composer", chatId, "fileAttachments"]);

export const getComposerImageAttachments = (
  state: any,
  { chatId }: SelectorArgs,
) => get(state, ["chat", "composer", chatId, "imageAttachments"]);

export const getComposerLinkPreview = (state: any, { chatId }: SelectorArgs) =>
  get(state, ["chat", "composer", chatId, "linkPreview"]);

export const getComposerLinkAttachments = (
  state: any,
  { chatId }: SelectorArgs,
) => values(get(state, ["chat", "composer", chatId, "linkAttachments"]));
